module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iIdZq"))).then(() => parcelRequire('f4eak'));